import React, {Fragment} from 'react';
import _ from 'lodash';
import Icon from "../Icon";
import { Link } from "react-router-dom";
import createLink from "../../../libs/createLink";
import Avatar from "../Avatar";
import {PageLoader, SpinLoader} from "../Loader";
import {isNoFollowProfil} from "../../../libs/helper";
import {useInfiniteQuery} from "@tanstack/react-query";
import {fetchLikes, LIKES_KEY} from "../../../api/public-voissa/likes";
import InfiniteScroll from "react-infinite-scroll-component";

const limit = 10;

const LikeList = ({
          likeType = null,
          parentId = null,
          handleClose = () =>{}
      }) =>{

    const {isSuccess : isSuccessLikes, isFetched : isFetchedLikes, data : dataLikes, fetchNextPage : fetchNextPageLikes, hasNextPage : hasNextPageLikes} = useInfiniteQuery(
        [LIKES_KEY, parentId],
        ({pageParam = 1}) => fetchLikes(likeType, parentId, {page : pageParam, limit}),
        {
            staleTime : (60 * 60 * 2),
            enabled : !!parentId && !!likeType,
            getNextPageParam: (lastPage, pages) => {
                return lastPage && lastPage.more ? pages.length + 1 : undefined
            }
        }
    );

    let listPages = _.get(dataLikes, 'pages') || [];
    let totalLike = _.get(dataLikes, 'pages[0].total') || 0;

    return !isSuccessLikes ? (
        <div id="like-popup" className={"modal-container"}>
            <PageLoader />
        </div>
    ) : (
        <div id="like-popup" className={"modal-container"}>
            <div className="modal-topline" >
                {totalLike} personne{totalLike > 1 ? 's' : ''} {totalLike > 1 ? 'ont' : 'a'} aimé
                <span onClick={() => handleClose()}><Icon type="close"/></span>
            </div>
            <div className="like-list">
                <ul id="like-list-container" className="like-list-container">
                    <InfiniteScroll
                        dataLength={listPages.length}
                        next={() => fetchNextPageLikes()}
                        hasMore={hasNextPageLikes}
                        loader={<SpinLoader key={isFetchedLikes} />}
                        scrollableTarget="like-list-container"
                    >
                            {listPages.map((data, page) =>(
                                <Fragment key={`page_${page}`}>
                                    {data.data.map((like) => {
                                        let relLinkProfil = isNoFollowProfil(like.owner) ? { rel: "nofollow" } : {};
                                        if (_.get(like,'owner._id')) {
                                            return (
                                                <Link to={createLink("userProfile", like.owner)} key={like.owner._id} {...relLinkProfil}>
                                                    <li>
                                                        <Avatar avatar={like.owner.profile.avatar}
                                                                gender={like.owner.profile.gender}
                                                                className="user-thumb"
                                                                alt=""/> {like.owner.username}
                                                    </li>
                                                </Link>)
                                        } else return <div></div>;
                                    })}
                                </Fragment>
                            ))}

                    </InfiniteScroll>
                </ul>
            </div>
        </div>
    )
};

export default LikeList;